import React, { useEffect, useRef } from 'react'
import { withRouter } from 'react-router'
import { getResourceEmbedConfig } from '../../../redux/actions'
import { connect } from 'react-redux'

import * as pbi from 'powerbi-client'
import { setTimeout } from 'timers'

import { DashboardDisplayProps } from './DashBoardContainer.models'
import Dashboard from '../../../components/resourceCatalog/dashboard/Dashboard'
import Preloader from '../../../components/prealoder/Preloader'

let tokenTimer: NodeJS.Timeout | undefined

const DashboardContainer = (props: any) => {
  const {
    user,
    embedConfigLoaded,
    embedConfig,
    preloader,
    getResourceEmbedConfig,
  } = props
  const dashboard = props.match.params as DashboardDisplayProps
  const userRef = useRef(user)

  useEffect(() => {
    if (user && user.access_token && !tokenTimer) {
      getResourceEmbedConfig(dashboard.resourceId, user.access_token)
    }
    userRef.current = user
  }, [user, dashboard, getResourceEmbedConfig])

  useEffect(() => {
    if (embedConfig && !tokenTimer) {
      const expirationTimeout =
        new Date(embedConfig.expiration).getTime() - new Date().getTime()
      console.log('PowerBi token expire in: ' + expirationTimeout)
      tokenTimer = setTimeout(() => {
        tokenTimer = undefined
        getResourceEmbedConfig(
          dashboard.resourceId,
          userRef.current.access_token
        )
      }, expirationTimeout)
    }

    if (embedConfig?.id) {
      const dashboardRoot = document.getElementById('dashboard') as HTMLElement
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      )

      if (!(dashboardRoot.childElementCount > 0)) {
        const powerBiConfig: pbi.IEmbedConfiguration = {
          ...embedConfig,
          settings: {
            layoutType: pbi.models.LayoutType.Custom,
            customLayout: {
              displayOption: pbi.models.DisplayOption.FitToWidth,
            },
          },
          tokenType: pbi.models.TokenType.Embed,
        }
        powerbi.embed(dashboardRoot, powerBiConfig)
      } else {
        powerbi
          .get(dashboardRoot)
          .setAccessToken(embedConfig.accessToken)
          .then(() => console.log('PowerBI token refreshed'))
      }
    }
  }, [embedConfig, dashboard.resourceId, getResourceEmbedConfig])

  useEffect(() => {
    return () => (tokenTimer ? clearTimeout(tokenTimer) : undefined)
  }, [])

  return (
    <div>
      {preloader.visible ? <Preloader /> : embedConfigLoaded && <Dashboard />}
    </div>
  )
}

function mapStateToProps(state: any) {
  return {
    user: state.oidc.user,
    embedConfig: state.activeResource.embedConfig,
    embedConfigLoaded: state.activeResource.embedConfigLoaded,
    preloader: state.preloader,
  }
}

export default withRouter(
  connect(mapStateToProps, { getResourceEmbedConfig })(DashboardContainer)
)
